import React from 'react';
import UserProfileSettingsForm from './UserProfileSettingsForm';
import useAppSelector from '../../app/redux/useAppSelector';
import SettingsContainerView from '../../settings/SettingsContainerView';

const UserProfileSettingsView = () => {
  const user = useAppSelector((state) => state.session.user);
  return (
    <SettingsContainerView title="Profile">
      <UserProfileSettingsForm user={user} />
    </SettingsContainerView>
  );
};

export default UserProfileSettingsView;
